/** Checkout and its MyPOS return pages share the compact order header. */
export function isOrderPath(path: string): boolean {
  const trimmed = path.replace(/\/$/, '') || '/'
  const withoutLocale = trimmed === '/en' || trimmed === '/bg'
    ? '/'
    : trimmed.startsWith('/en/')
      ? trimmed.slice(3)
      : trimmed.startsWith('/bg/')
        ? trimmed.slice(3)
        : trimmed
  return withoutLocale === '/order' || withoutLocale.startsWith('/order/')
}
